// components/startProject/StartProcess.jsx
import {
  FiCheckCircle,
  FiCode,
  FiLayout,
  FiSearch,
  FiTrendingUp,
  FiUploadCloud,
} from "react-icons/fi";
import "./process.css";

import {
  FiAlertTriangle,
  FiClock,
  FiRefreshCcw,
  FiShield
} from "react-icons/fi";

const processBenefits = [
  {
    title: "Clear Milestones & Predictable Timelines",
    desc: "Our software development process is milestone-driven, ensuring defined deliverables, realistic timelines, and full transparency across the project lifecycle.",
    icon: <FiClock />,
  },
  {
    title: "Early Risk Identification & Cost Control",
    desc: "Technical, performance, and scalability risks are identified early to avoid delays, scope creep, and unexpected costs.",
    icon: <FiAlertTriangle />,
  },
  {
    title: "Built-In Quality Assurance",
    desc: "Quality assurance is integrated into every development phase, ensuring secure, stable, and high-performing software before deployment.",
    icon: <FiShield />,
  },
  {
    title: "Scalable & Future-Ready Delivery",
    desc: "Our structured approach ensures your software can scale efficiently as your business grows and requirements evolve.",
    icon: <FiTrendingUp />,
  },
  {
    title: "Long-Term Support & Continuous Improvement",
    desc: "Post-launch, we provide maintenance, optimization, feature upgrades, and technical support for long-term success.",
    icon: <FiRefreshCcw />,
  },
];


const steps = [
  {
    title: "Requirement Analysis & Planning",
    desc: "We analyze your business objectives, target users, technical requirements, and success metrics to define a clear software development roadmap.",
    icon: <FiSearch />,
  },
  {
    title: "UI/UX Design & System Architecture",
    desc: "Our team designs intuitive user experiences and scalable system architecture to ensure performance, security, and future growth.",
    icon: <FiLayout />,
  },
  {
    title: "Agile Software Development",
    desc: "Using agile development methodology, we build your product in structured sprints with regular demos, feedback cycles, and progress tracking.",
    icon: <FiCode />,
  },
  {
    title: "Testing & Quality Assurance",
    desc: "We perform functional, performance, and security testing to ensure your software is reliable, stable, and production-ready.",
    icon: <FiCheckCircle />,
  },
  {
    title: "Deployment & Launch",
    desc: "We deploy your application using secure and optimized environments, ensuring smooth launch, monitoring, and system stability.",
    icon: <FiUploadCloud />,
  },
  {
    title: "Ongoing Support & Scaling",
    desc: "Post-launch, we provide maintenance, feature enhancements, performance optimization, and long-term scaling support.",
    icon: <FiTrendingUp />,
  },
];


export default function StartProcess() {
  return (
    <section className="sp-process" aria-label="Software Development Process">
      <div className="sp-process-inner">
        <span className="sp-process-badge">Our Process</span>

        <h2 className="sp-process-title">
          Our Software Development <span>Process</span>
        </h2>

        <p className="sp-process-intro">
          We follow a transparent and structured software development process
          that minimizes risk, ensures quality, and keeps you informed at every
          stage — from idea to launch and beyond.
        </p>
        <div className="sp-process-layout">
          {/* LEFT – Timeline */}
          <div className="sp-process-timeline">
            {steps.map((step, index) => (
              <div key={step.title} className="sp-process-step">
                <div className="sp-step-left">
                  <div className="sp-step-icon">{step.icon}</div>
                  <span className="sp-step-line" />
                </div>

                <div className="sp-step-content">
                  <span className="sp-step-number">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <h4>{step.title}</h4>
                  <p>{step.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="sp-process-timeline">
            {processBenefits.map((step, index) => (
              <div key={step.title} className="sp-process-step">
                <div className="sp-step-left">
                  <div className="sp-step-icon">{step.icon}</div>
                  <span className="sp-step-line" />
                </div>

                <div className="sp-step-content">
                  <span className="sp-step-number">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <h4>{step.title}</h4>
                  <p>{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
